import React from 'react';
import { Card, Text, useMantineTheme, SimpleGrid, Box } from '@mantine/core';

import { sqlDateToHumanDate, stringDivider, safeValue, arrayObjectToStringWithDivider } from "../../utils/globalFunctions";

import LabelContentInline from "../../components/general/LabelContentInline";
import SortSegmentedControl from "../../components/general/SortSegmentedControl";

const SudahSerahTerimaCard = ({ stateData, stateSortList, stateSortSelected, fnSort, fnSelectedData }) => {

    const theme = useMantineTheme();

    return (
        <React.Fragment>

            <SortSegmentedControl
                stateSortList={stateSortList}
                stateSortSelected={stateSortSelected}
                fnSort={fnSort}
                stateStyle={{ marginBottom: theme.spacing.md }}
            />

            <SimpleGrid
                cols={1}
                spacing='md'
                breakpoints={[
                    { minWidth: 'xl', cols: 3, spacing: 'md' },
                    { minWidth: 'lg', cols: 3, spacing: 'md' },
                    { minWidth: 'md', cols: 2, spacing: 'md' },
                    { minWidth: 'sm', cols: 2, spacing: 'md' },
                    { minWidth: 'xs', cols: 2, spacing: 'md' },
                ]}
            >
                {Object.keys(stateData).map((key, index) => {
                    return (
                        <Card
                            key={key}
                            shadow=''
                            radius="md"
                            withBorder={true}

                            style={{
                                borderColor: theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[7],
                                backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7],
                                overflow: 'unset',
                                cursor: 'pointer',
                            }}

                            onClick={() => {
                                fnSelectedData(stateData[key]);
                            }}
                        >
                            <Card.Section p='sm'>
                                <Text size="sm">
                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.customerName.caption}
                                        stateContent={
                                            <React.Fragment>
                                                <Text size="sm" fw={500} lineClamp={1}>
                                                    {stateData[key].customer_name}
                                                </Text>

                                                <Text size="xs" lineClamp={1} color='dimmed'>
                                                    {stateData[key].customer_category_name}
                                                </Text>
                                            </React.Fragment>
                                        }
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.deliveryId.caption}
                                        stateContent={stringDivider(stateData[key].delivery_jemput_id, [4, 6, 8], '.', '[Nomor Penjemputan]')}
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel='Barang'
                                        stateContent={
                                            <Text lineClamp={1}>
                                                {arrayObjectToStringWithDivider(stateData[key].barang, 'delivery_jemput_barang_name', ', ', ' - ')}
                                            </Text>
                                        }
                                        stateDivider={true}
                                    />

                                    {/* <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.barangKeluhan.caption}
                                        stateContent={<Text lineClamp={2}>{safeValue(stateData[key].barang_keluhan, '-')}</Text>}
                                        stateDivider={true}
                                    /> */}

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.tanggalPenjemputan.caption}
                                        stateContent={sqlDateToHumanDate({
                                            stateDate: stateData[key].waktu_jemput,
                                            stateWithTime: true,
                                            stateLang: 'id',
                                            stateIsShort: false,
                                            stateDay: true,
                                            stateDefaultValue: ' - ',
                                            stateDateType: 'day',
                                            stateWithSecond: false
                                        })}
                                        stateDivider={true}
                                    />

                                    <LabelContentInline
                                        stateColLabel={4}
                                        stateLabel={stateSortList.deliveryMan.caption}
                                        stateContent={
                                            <Box>
                                                <Text lineClamp={1}>{safeValue(stateData[key].delivery_man_name, '-')}</Text>
                                            </Box>
                                        }
                                        stateDivider={false}
                                    />
                                </Text>
                            </Card.Section>
                        </Card>
                    )
                })}
            </SimpleGrid>
        </React.Fragment>
    )
}

export default React.memo(SudahSerahTerimaCard);